module.exports = __webpack_public_path__ + "img/topic_banner.c48f8b64.png";